import { useEffect, useState } from "react";
import { Link } from "react-router";
import { api, type LongTermStock } from "../lib/api.js";
import { AuthGate } from "../components/AuthGate.js";
import { ErrorText } from "../components/ui.js";

export function LongTermPage() {
  return (
    <AuthGate>
      <LongTermInner />
    </AuthGate>
  );
}

function LongTermInner() {
  const [stocks, setStocks] = useState<LongTermStock[]>([]);
  const [error, setError] = useState<unknown>(null);
  const reload = () => api.longTerm().then((r) => setStocks(r.stocks)).catch(setError);
  useEffect(() => {
    void reload();
  }, []);

  return (
    <section>
      <h1>長期保有</h1>
      <p className="muted">所持銘柄のうち、優待マスタに長期保有条件がある銘柄の達成状況です。取得日が未設定のロットは保有中として数えます。</p>
      <ErrorText error={error} />
      {stocks.map((s) => (
        <div className="card" key={s.code}>
          <h2>
            <Link to={`/stocks/${s.code}`}>{s.code}</Link> {s.name ?? ""}
          </h2>
          {!s.hasRule ? (
            <p className="muted">長期保有条件は未登録です。</p>
          ) : (
            <>
              <dl className="dl">
                <dt>条件</dt>
                <dd>
                  {s.requiredShares}株以上を {s.requiredCount} 回連続（現在 {s.currentShares}株）
                </dd>
                <dt>連続回数</dt>
                <dd>
                  {s.streak} / {s.requiredCount} {s.achieved && <span className="badge executed">達成</span>}
                </dd>
                <dt>次の判定日</dt>
                <dd>
                  {s.nextRecordDate ?? "-"}
                  {s.nextLastTradingDay && <span className="muted">（権利付最終日 {s.nextLastTradingDay}）</span>}
                </dd>
              </dl>
              {s.currentShares < s.requiredShares && <p className="warn">保有株数が基準に足りません。次の基準日で継続が途切れます。</p>}
              <table className="table">
                <thead>
                  <tr>
                    <th>基準日</th>
                    <th>保有株数</th>
                    <th>判定</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {s.records
                    .filter((r) => !r.future)
                    .slice(-8)
                    .map((r) => (
                      <tr key={r.recordDate}>
                        <td>{r.recordDate}</td>
                        <td>{r.sharesHeld}</td>
                        <td>{r.qualified ? "○" : "×"}{r.manual && <span className="muted">（手動）</span>}</td>
                        <td>
                          <button
                            className="btn small"
                            type="button"
                            onClick={async () => {
                              await api.setLongTermRecord({ stockCode: s.code, recordDate: r.recordDate, sharesHeld: r.sharesHeld, qualified: !r.qualified });
                              await reload();
                            }}
                          >
                            反転
                          </button>
                          {r.manual && (
                            <button
                              className="btn small"
                              type="button"
                              onClick={async () => {
                                await api.clearLongTermRecord({ stockCode: s.code, recordDate: r.recordDate });
                                await reload();
                              }}
                            >
                              自動に戻す
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      ))}
      {stocks.length === 0 && <p className="muted">所持銘柄がありません。</p>}
    </section>
  );
}
